import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { TranscriptService } from '../../../coaching-base/transcript.service';
import { Dependencies } from '../../../store';
import { pluck } from '../../../store.decorator';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    DeleteTranscriptQuotes,
    deleteTranscriptQuotesResult,
} from './delete-transcript-quotes.action';

export const deleteTranscriptQuotesEpic = (
    action: ActionsObservable<
        PayloadAction<ActionType, DeleteTranscriptQuotes>
    >,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<any> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES),
        mergeMap((act: PayloadAction<ActionType, DeleteTranscriptQuotes>) => {
            const rootState = pluck<TranscriptDialogState>(
                state.value,
                act.storePath,
            );
            const ctsService =
                deps.injector.get<TranscriptService>(TranscriptService);

            return ctsService
                .deleteEntries(
                    rootState.transcript.platform,
                    rootState.transcript.transcriptId,
                    act.payload.transcriptQuoteIds,
                )
                .pipe(
                    map(() => {
                        return deleteTranscriptQuotesResult(
                            {
                                ...act.payload,
                            },
                            act.storePath,
                        );
                    }),
                    catchError((err) => {
                        console.log(err);
                        return of(null);
                    }),
                );
        }),
    );
